module.exports = __webpack_public_path__ + "static/media/giftcard-newmom-mobile.619af7e1.png";